import React from 'react';
// @material-ui/core
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';

const Spin = ({ url }) => {
  return (
    <Card className='bg-fill-stroke-400'>
      <Box display="flex" px="24px" pt="24px" pb="30px">
        <Grid container item spacing={4}>
          <Grid item xs={12} md={5}>
            <Box justifyContent='center' alignItems='center' display='flex' height='100%'>
              <img 
                src="https://cdn.builder.io/api/v1/image/assets%2Fe6839c79bd834f789172c7e094479efc%2F974e4cc9838c4d479ad90424e283f3cc" 
                alt="Imagen"
                style={{
                  width: '100%',
                  maxWidth: '180px'
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
            <Box className='mt-2' display='flex' flexDirection='column' justifyContent='center' alignItems='center'>

              <p style={{
                color: '#FFFFFF',
                fontWeight: 700,
                fontSize: '16px',
                textAlign: 'center',
                marginBottom: '15px',
                fontFamily: 'Inter'
              }}>
                ¡No olvides tus puntos!
              </p>

              <p style={{
                color: '#FFFFFF',
                fontWeight: 400,
                fontSize: '14px',
                textAlign: 'center',
                marginBottom: '22px',
                fontFamily: 'Inter',
                maxWidth: 320
              }}>
                Al pagar esta referencia generarás puntos <span style={{ color: '#00B7CF', fontWeight: 'bold' }}>Spin Premia</span>, agrega tu cuenta para no perderlos.
              </p>
              <button
                onClick={() => { window.open(url, '_blank') }}
                style={{
                  backgroundColor: ' #FF5D20',
                  color: ' white',
                  padding: ' 15px 20px',
                  border: ' none',
                  borderRadius: ' 5px;',
                  cursor: ' pointer',
                  fontWeight: ' bold',
                  fontSize: ' 16px',
                  width: '320px',
                  display: 'inline-flex',
                  appearance: 'none',
                  alignItems: 'center',
                  justifyContent: 'center',
                  userSelect: 'none',
                  position: 'relative',
                  verticalAlign: 'middle',
                  outlineOffset: '2px',
                  lineHeight: 1.2,
                  fontWeight: 600,
                  transitionProperty: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
                  transitionDuration: '200ms',
                  height: '40px',
                  minWidth: '40px',
                  maxWidth: '222.5px',
                  fontSize: '16px',
                  paddingInlineStart: '16px',
                  paddingInlineEnd: '16px',
                  color: '#FFFFFF',
                  backgroundColor: 'rgb(255, 93, 32)',
                  fontFamily: `Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`,
                  whiteSpace: 'nowrap',
                  outline: 'transparent solid 2px',
                  borderRadius: '0.375rem',
                  alignSelf: 'center'
                }}
              >
                Agregar mi cuenta ahora
              </button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Card>
  )
};

export default Spin;